module.exports = __webpack_public_path__ + "static/media/ic_pagination_next.a758874a.svg";